<template>
  <v-card elevation="4" rounded class="main-tabs-card" color="surface">
    <v-tabs
      v-model="tabValue"
      color="primary"
      align-tabs="center"
      class="main-tabs"
    >
      <v-tab value="alerts" class="tab-item">
        <v-icon class="mr-2">mdi-bell-alert</v-icon>
        {{ $t("alertsList") }}
      </v-tab>
      <v-tab value="maintenance" class="tab-item">
        <v-icon class="mr-2">mdi-wrench</v-icon>
        {{ $t("maintenance") }}
      </v-tab>
    </v-tabs>

    <v-window v-model="tabValue">
      <slot />
    </v-window>
  </v-card>
</template>

<script>
export default {
  name: "TabNavigation",
  props: {
    modelValue: {
      type: String,
      default: "alerts",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    tabValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        if (value !== this.modelValue) {
          this.$emit("update:modelValue", value);
        }
      },
    },
  },
};
</script>

<style scoped>
.main-tabs-card {
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.main-tabs {
  background: var(--v-theme-surface);
  box-shadow: none !important;
  border: none !important;
}

.tab-item {
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.5px;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  min-height: 40px;
  width: 20%;
  max-width: 20%;
  font-size: 1em;
  padding: 0.7em 0.2em;
  box-sizing: border-box;
}

.tab-item.v-tab--selected,
.tab-item.v-tab--active,
.tab-item.v-tab--selected:focus,
.tab-item.v-tab--active:focus {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

@media (max-width: 768px) {
  .main-tabs-card {
    width: 100%;
    max-width: 100%;
    padding: 0.5em 0.2em;
  }
  .main-tabs {
    width: 100%;
    max-width: 100%;
    font-size: 0.9em;
  }
  .tab-item {
    min-height: 36px;
    font-size: 0.85em;
    width: 50%;
    max-width: 50%;
    padding: 0.5em 0.1em;
  }
}
</style>
